import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StandbyGetAlternativeOffersEffect } from './standby-get-alternative-offers.effect';
import { standbyGetAlternativeOffersReducer } from './standby-get-alternative-offers.reducer';
import {
  STANDBY_GET_ALTERNATIVE_OFFERS_STORE_NAME,
  StandbyGetAlternativeOffersState,
} from './standby-get-alternative-offers.state';

/** Token of the StandbyGetAlternativeOffers reducer */
export const STANDBY_GET_ALTERNATIVE_OFFERS_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<StandbyGetAlternativeOffersState, Action>
>('Feature StandbyGetAlternativeOffers Reducer');

/** Provide default reducer for StandbyGetAlternativeOffers store */
export function getDefaultStandbyGetAlternativeOffersReducer() {
  return standbyGetAlternativeOffersReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(STANDBY_GET_ALTERNATIVE_OFFERS_STORE_NAME, STANDBY_GET_ALTERNATIVE_OFFERS_REDUCER_TOKEN),
    EffectsModule.forFeature([StandbyGetAlternativeOffersEffect]),
  ],
  providers: [
    { provide: STANDBY_GET_ALTERNATIVE_OFFERS_REDUCER_TOKEN, useFactory: getDefaultStandbyGetAlternativeOffersReducer },
  ],
})
export class StandbyGetAlternativeOffersStoreModule {
  public static forRoot<T extends StandbyGetAlternativeOffersState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<StandbyGetAlternativeOffersStoreModule> {
    return {
      ngModule: StandbyGetAlternativeOffersStoreModule,
      providers: [{ provide: STANDBY_GET_ALTERNATIVE_OFFERS_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
